import { createSlice } from "@reduxjs/toolkit";


export const reducer = createSlice({
    name: "reducer",
    initialState: {},
    reducers: {}
})

export default reducer.reducer